<template>
    <generic-page :key="creatorVideo?.id">
        <b-btn variant="link" size="lg" class="pl-0" to="/video/index">
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            {{ $t("All Videos") }}
        </b-btn>

        <div v-if="loading">
            <generic-loading />
        </div>
        <div v-else>
            <user-header
                class="border-bottom mt-3"
                :disableInterest="true"
                :standardMap="standardMap"
            >
            </user-header>

            <h4
                v-if="creatorVideo.message"
                class="position-absolute text-center glass glass-smoke mx-auto p-1 px-2 mb-0"
                style="top: 0; width: 100%; z-index: 1"
            >
                {{ creatorVideo.message }}
            </h4>

            <video-player
                class="img-fluid"
                :controls="true"
                :autoplay="true"
                :loop="true"
                :creatorVideo="creatorVideo"
                :poster="creatorVideo.previewUrl"
                :mp4Url="creatorVideo.mp4Url"
                :webmUrl="creatorVideo.webmUrl"
            />

            <div v-if="moreVideos.length">
                <h5 class="mt-3">
                    {{ $t("More Videos from") }}
                    {{ standardMap.name }}
                </h5>
                <b-list-group flush>
                    <b-list-group-item
                        action
                        :key="creatorVideo.id"
                        v-for="creatorVideo in moreVideos"
                        @click="
                            $router.push({
                                name: 'videoView',
                                params: {
                                    id: creatorVideo.id,
                                },
                            })
                        "
                    >
                        <video-avatar :creatorVideo="creatorVideo" />
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
    </generic-page>
</template>

<script>
import VideoPlayer from "@/components/utility/VideoPlayer";
import UserHeader from "@/components/userHeader/UserHeader";
import VideoAvatar from "@/components/video/VideoAvatar";

export default {
    data() {
        return {
            creatorVideo: null,
            standardMap: null,
            moreVideos: null,
            loading: true,
        };
    },
    mounted() {
        this.refresh();
    },
    watch: {
        $route(to) {
            if (to?.params?.id !== this.creatorVideo?.id) {
                this.refresh();
            }
        },
    },
    methods: {
        refresh() {
            this.api
                .post(`/creatorVideo/${this.$route.params?.id}/get`)
                .then((response) => {
                    this.loading = false;

                    this.creatorVideo = response.data.creatorVideo;
                    this.standardMap = response.data.standardMap;
                    this.moreVideos = response.data.moreVideos;
                });
        },
    },
    components: {
        VideoPlayer,
        VideoAvatar,
        UserHeader,
    },
};
</script>